module.exports = "/static/img/placeholder.svg?dd8d30a523403dd515a1d56fd8eb5f88";